import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { persist, store } from './_store';
import { history } from './_helpers'
import { PersistGate } from 'redux-persist/lib/integration/react';
import "./index.scss";
// import "assets/css/material-dashboard-react.css?v=1.4.1";
import "assets/css/material-dashboard-react.css";
import indexRoutes from "routes/index.jsx";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme'
const muiTheme = getMuiTheme({
    stepper: {
        iconColor: 'green' // or logic to change color
    }
})
// const hist = createBrowserHistory();

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persist}>
            <MuiThemeProvider muiTheme={muiTheme}>
                <Router history={history}>
                    {indexRoutes}
                </Router>
            </MuiThemeProvider>
        </PersistGate>
    </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js